import React from 'react';
import Acord24Form from './Acord24Form';
import type { Acord24FormRef } from './Acord24Form';

export type { Acord24FormRef };

// Every prop the plain form takes, minus the one this wrapper sets. Spreading them keeps the
// "+ ACORD 101" variant in lockstep with the base form: before this, the wrapper re-listed the
// props by hand and silently dropped onLoadingChange, onCoverageMapping and friends, so on a
// +101 form the parent never learned which policies mapped (every policy looked unmapped) and
// the Loading state could never clear.
type Acord24With101FormProps = Omit<React.ComponentPropsWithoutRef<typeof Acord24Form>, 'showAcord101'>;

const Acord24With101Form = React.forwardRef<Acord24FormRef, Acord24With101FormProps>(
  function Acord24With101Form(props, ref) {
    return <Acord24Form ref={ref} showAcord101 {...props} />;
  }
);

export default Acord24With101Form;
